function toDateObject(date: Date | string | null): Date | null {
  if (!date) return null;
  if (date instanceof Date) return date;

  try {
    const dateObj = new Date(date);
    return isNaN(dateObj.getTime()) ? null : dateObj;
  } catch {
    return null;
  }
}

export function formatDateToDDMMYYYY(date: Date | string | null): string {
  const dateObj = toDateObject(date);
  return dateObj ? dateObj.toLocaleDateString('de-DE') : '';
}

// Serialize to a local date-only string (yyyy-MM-dd) so the day never shifts
// through UTC the way Date.toISOString() does.
export function toLocalDateString(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function isDateRangeActive(startDate: Date | null, endDate: Date | null): boolean {
  if (!startDate || !endDate) return false;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const start = new Date(startDate);
  start.setHours(0, 0, 0, 0);

  const end = new Date(endDate);
  end.setHours(0, 0, 0, 0);

  return today >= start && today <= end;
}

export function isEndDateBeforeStartDate(startDate: Date | null, endDate: Date | null): boolean {
  if (!startDate || !endDate) {
    return false;
  }
  return endDate < startDate;
}

export function getDateTimestamp(date: Date | string | null): number | null {
  const dateObj = toDateObject(date);
  return dateObj ? dateObj.getTime() : null;
}

export function addDays(localDate: Date, days: number): Date {
  return new Date(localDate.getFullYear(), localDate.getMonth(), localDate.getDate() + days);
}

export function createLocalDate(): Date {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
}

export function createTomorrow(): Date {
  return addDays(createLocalDate(), 1);
}

export function parseLocalDate(date: Date | string): Date {
  const today = new Date(date);
  today.setHours(0, 0, 0, 0);
  return today;
}
